import './relative-date-select.scss';
import { timeUnitList, timeUnitList2 } from '@/common/util/expr-const';
import { isPlainObject } from '@cainiaofe/cn-ui-m/es/utils/object';
const { CnAsyncSelect, CnNumberPicker } = window.CNUI || {};
export function RelativeRangeSelect(props) {
    const { value, onChange, hideTime, componentName } = props;
    let realValue = [];
    if (Array.isArray(value)) {
        realValue = value;
    }
    else if (isPlainObject(value)) {
        realValue = [value, {}];
    }
    else {
        realValue = [{}, {}];
    }
    const changeValue = (index, key, v) => {
        const newV = realValue.slice();
        let newItem = { ...realValue[index], [key]: v };
        newV[index] = newItem;
        onChange(newV);
    };
    let realTimeUnitList = [...timeUnitList];
    if (componentName === 'CnDateRangePickerPro') {
        realTimeUnitList = [...timeUnitList2, ...timeUnitList];
    }
    return (React.createElement("div", { className: '' }, realValue.map((item, index) => {
        const { rela, num, unit, time } = item || {};
        return (React.createElement("div", { className: 'relative-date-select-wrap' },
            React.createElement(CnAsyncSelect, { value: rela, onChange: changeValue.bind(null, index, 'rela'), size: 'small', dataSource: [
                    {
                        label: '前',
                        value: 'subtract',
                    },
                    {
                        label: '后',
                        value: 'add',
                    },
                ], style: { width: '46px', flex: '0 0 46px' } }),
            React.createElement(CnNumberPicker, { value: num, onChange: changeValue.bind(null, index, 'num'), size: 'small', min: 0, style: { width: '40px', flex: '0 0 40px' } }),
            React.createElement(CnAsyncSelect, { value: unit, onChange: changeValue.bind(null, index, 'unit'), size: 'small', dataSource: realTimeUnitList, style: { width: '46px', flex: '0 0 46px' } }),
            !hideTime && (React.createElement(CnAsyncSelect, { value: time, onChange: changeValue.bind(null, index, 'time'), size: 'small', dataSource: [
                    {
                        label: '00:00:00',
                        value: 'startOf',
                    },
                    {
                        label: '此刻',
                        value: 'now',
                    },
                    {
                        label: '23:59:59',
                        value: 'endOf',
                    },
                ], style: { width: '60px', flex: '0 0 60px' } }))));
    })));
}
